import { Component, computed, inject, signal } from '@angular/core';
import { OrderService } from '../../../core/services/order.service';

const FALLBACK_REASON = 'The counter cancelled this order. Please check with our staff.';

@Component({
  selector: 'app-order-cancelled-notice',
  templateUrl: './order-cancelled-notice.html',
  styleUrl: './order-cancelled-notice.scss'
})
export class OrderCancelledNotice {
  private readonly orderService = inject(OrderService);

  readonly fallbackReason = FALLBACK_REASON;

  /** Dismissal is per-cancellation and lives here, so hiding the notice doesn't erase the cancelled state other screens read. */
  private readonly dismissedOrderPublicId = signal<string | null>(null);

  readonly cancellation = computed(() => {
    const cancellation = this.orderService.cancellation();
    return cancellation && cancellation.orderPublicId !== this.dismissedOrderPublicId()
      ? cancellation
      : null;
  });

  dismiss(): void {
    this.dismissedOrderPublicId.set(this.orderService.cancellation()?.orderPublicId ?? null);
  }
}
